import React, { useEffect, useMemo, useRef, useState, Fragment } from 'react';
import './ticker.scss';
import LogoA3Elecciones26M from '../../assets/logo_elecciones26m.svg';
import { getSite, customAcronym } from '../../constants';

const ANIMATION_TIME = 20;

const Ticker = ({ place, results }) => {
  const [leftPosition, setLeftPosition] = useState(0);
  const tickerTextElementRef = useRef();
  const style = useMemo(
    () => ({
      left: `${-leftPosition}px`,
      transition: `left ${leftPosition / ANIMATION_TIME}s linear`
    }),
    [leftPosition]
  );
  useEffect(() => {
    setLeftPosition(tickerTextElementRef.current.getBoundingClientRect().width);
  });

  return (
    <div className="ticker_container font-isidora">
      <div className="ticker">
        <div className="ticker_logo">
          <img
            src={LogoA3Elecciones26M}
            alt="Logo de Antena3 Elecciones"
            title="A3 Elecciones"
          />
        </div>
        <div className="ticker_content">
          <div className="ticker_text" ref={tickerTextElementRef} style={style}>
            {place && results && (
              <Fragment>
                <span className="province_name">{`RESULTADOS AUTONÓMICOS EN ${place.name} `}</span>
                <span className="province_separator">|</span>{' '}
                {results
                  .filter(item => item.seats)
                  .map(result => (
                    <span
                      key={customAcronym(result, getSite())}
                      className="province_percent"
                    >
                      {customAcronym(result, getSite())} : {result.seats} esc.
                      {' | '}
                    </span>
                  ))}
              </Fragment>
            )}
          </div>
        </div>
        <div className="ticker_hashtag">
          <a
            href="https://twitter.com/hashtag/EleccionesA3N?f=tweets"
            target="_parent"
          >
            #EleccionesA3N
          </a>
        </div>
      </div>
    </div>
  );
};

export default Ticker;
